import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Breadcrumb from "../../Components/Navigation/Breadcrumbs/Breadcrumbs";
import { Button, Card, CardContent, Dialog, FormHelperText, Grid } from "@material-ui/core";
import ConfirmationModal from "../../Components/Modal/Modal";
import { useLocation, Redirect } from "react-router-dom";
import Signifier from "../../Components/Signifier";
import KenexaAPISection from "../../Components/Modal/InboundModals/KenexaAPISection";
import PeopleMatterAPISection from "../../Components/Modal/InboundModals/PeopleMatterAPISection";
import TaleoAPISection from "../../Components/Modal/InboundModals/TaleoAPISection";
import WorkableAPISection from "../../Components/Modal/InboundModals/WorkableAPISection";
import { deleteApi, editApi } from "../../Services/API/AtsApi";
import { StyledTextField } from "../../Components/TextField/TextField";

function AtsApiDetailed() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "90%",
      marginBottom: "50px",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
    sensitiveSection: {
      width: "100%",
      height: "25%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      paddingTop: "20px",
    },
    sensitiveButton: {
      [theme.breakpoints.down("sm")]: {
        maxWidth: "none",
        width: "100%",
      },
      width: "200px",
    },
    error: {
      color: theme.palette.error.main,
    },
    textField: {
      "& .Mui-error": {
        color: theme.palette.error.main,
      },
      "& .MuiFormHelperText-root": {
        color: theme.palette.error.main,
      },
      "& .MuiInput-underline.Mui-error:after": {
        borderBottomColor: theme.palette.error.main,
      },
    },
    header: {
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        marginTop: "10px",
      },
      display: "flex",
    },
    descLabel: {
      margin: "0px",
      fontWeight: "700",
      marginBottom: "10px",
    },
    descValue: {
      margin: "0px",
      marginLeft: "5px",
      marginRight: "20px",
    },
    descBlock: {
      display: "flex",
    },
  }));

  const classes = useStyles();

  const location = useLocation();
  const [showInputError, setShowInputError] = useState(false);
  const [showSignifier, setShowSignifier] = useState(false);
  const [showError, setShowError] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [name, setName] = useState(location.state === undefined ? "" : location.state.name);
  const [endpoint, setEndpoint] = useState(location.state === undefined ? "" : location.state.endPoint);
  const [outputFileName, setOutputFileName] = useState(
    location.state === undefined ? "" : location.state.feedFileName,
  );
  const [version, setVersion] = useState(location.state === undefined ? "" : location.state.version);
  const [credential, setCredential] = useState(location.state === undefined ? "" : location.state.credential);
  const [userID, setUserID] = useState(location.state === undefined ? "" : location.state.userId);
  const [siteID, setSiteID] = useState(location.state === undefined ? "" : location.state.siteId);
  const [mappingFileName, setMappingFileName] = useState(
    location.state === undefined ? "" : location.state.mappingFileName,
  );
  const [processor, setProcessor] = useState(location.state === undefined ? "" : location.state.processor);
  const [additionalQuestionIds, setAdditionalQuestionIds] = useState(
    location.state === undefined ? "" : location.state.questions,
  );
  const [country, setCountry] = useState(location.state === undefined ? "" : location.state.countryValue);
  const [reqNumberFieldID, setReqNumberFieldID] = useState(
    location.state === undefined ? "" : location.state.postedDateReqNumberId,
  );
  const [companyName, setCompanyName] = useState(
    location.state === undefined ? "" : location.state.companyName,
  );
  const [businessUnits, setBusinessUnits] = useState(
    location.state === undefined ? "" : location.state.businessUnits,
  );
  const [addPostedDate, setAddPostedDate] = useState(
    location.state === undefined ? "" : location.state.addPostedDate,
  );
  const [processing, setProcessing] = useState(false);
  const [deleted, setDeleted] = useState(false);

  if (location.state === undefined) {
    return <Redirect to="/inboundfeeds" />;
  }

  const checkAllEntered = () => {
    if (name === "" || endpoint === "" || outputFileName === "") {
      return false;
    }
    switch (location.state.assemblyName) {
      case null:
        return false;
      case "BrassRing":
        if (
          version === "" ||
          credential === "" ||
          userID === "" ||
          siteID === "" ||
          mappingFileName === "" ||
          processor === "" ||
          reqNumberFieldID === ""
        ) {
          return false;
        }
        return true;
      case "PeopleMatter":
        if (companyName === "" || businessUnits === "") {
          return false;
        }
        return true;
      case "TaleoEnterprise":
        if (version === "" || userID === "" || credential === "") {
          return false;
        }
        return true;
      case "Workable":
        if (mappingFileName === "" || processor === "") {
          return false;
        }
        return true;
      default:
        return true;
    }
  };

  const data = {
    Id: location.state === undefined ? "" : location.state.id,
    Name: name === "" ? null : name,
    EndPoint: endpoint === "" ? null : endpoint,
    FeedFileName: outputFileName === "" ? null : outputFileName,
    CompanyName: companyName === "" ? null : companyName,
    BusinessUnits: businessUnits === "" ? null : businessUnits,
    Version: version === "" ? null : version,
    UserId: userID === "" ? null : userID,
    Credential: credential === "" ? null : credential,
    SiteId: siteID === "" ? null : siteID,
    Processor: processor === "" ? null : processor,
    Questions: additionalQuestionIds === "" ? null : additionalQuestionIds,
    MappingFileName: mappingFileName === "" ? null : mappingFileName,
    CountryValue: country === "" ? null : country,
    AddPostedDate: addPostedDate,
    PostedDateReqNumberId: reqNumberFieldID === "" ? null : reqNumberFieldID,
  };

  const callAPI = (func, responseMessage) => {
    setProcessing(true);
    func.then((res) => {
      setShowSignifier(true);
      if (res) {
        setResponseMessage(responseMessage);
        setShowError(false);
      } else {
        setShowError(true);
      }
      setProcessing(false);
    });
  };

  const callDelete = async () => {
    await deleteApi(location.state.id).then((response) => {
      if (response) {
        setDeleted(true);
        return true;
      }
    });
    return true;
  };

  const renderExtraFields = () => {
    switch (location.state.assemblyName) {
      case null:
        return null;
      case "BrassRing":
        return (
          <KenexaAPISection
            version={version}
            setVersion={setVersion}
            credential={credential}
            setCredential={setCredential}
            userID={userID}
            setUserID={setUserID}
            siteID={siteID}
            setSiteID={setSiteID}
            mappingFileName={mappingFileName}
            setMappingFileName={setMappingFileName}
            processor={processor}
            setProcessor={setProcessor}
            reqNumberFieldID={reqNumberFieldID}
            setReqNumberFieldID={setReqNumberFieldID}
            additionalQuestionIds={additionalQuestionIds}
            setAdditionalQuestionIds={setAdditionalQuestionIds}
            country={country}
            setCountry={setCountry}
            addPostedDate={addPostedDate}
            setAddPostedDate={setAddPostedDate}
            showInputError={showInputError}
          />
        );
      case "PeopleMatter":
        return (
          <PeopleMatterAPISection
            companyName={companyName}
            setCompanyName={setCompanyName}
            businessUnits={businessUnits}
            setBusinessUnits={setBusinessUnits}
            showInputError={showInputError}
          />
        );
      case "TaleoEnterprise":
        return (
          <TaleoAPISection
            serviceVersion={version}
            setServiceVersion={setVersion}
            username={userID}
            setUsername={setUserID}
            password={credential}
            setPassword={setCredential}
            showInputError={showInputError}
          />
        );
      case "Workable":
        return (
          <WorkableAPISection
            token={mappingFileName}
            setToken={setMappingFileName}
            additonalProperties={additionalQuestionIds}
            setAdditonalProperties={setAdditionalQuestionIds}
            requisitionStatuses={processor}
            setRequisitionStatuses={setProcessor}
            showInputError={showInputError}
          />
        );
      default:
        return null;
    }
  };

  if (deleted) {
    return <Redirect to="/inboundfeeds" />;
  }

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">Detailed ATS API</h1>
        <div className={classes.header}>
          <div className={classes.descBlock}>
            <p className={classes.descLabel}>FEED TYPE: </p>
            <p className={classes.descValue}>{location.state.assemblyName}</p>
          </div>
        </div>
        <div className={classes.root}>
          <Grid className={classes.cardContainer}>
            <Card className={classes.card}>
              <CardContent>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6}>
                    <StyledTextField
                      InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                      placeholder="Name"
                      label="Name"
                      variant="standard"
                      fullWidth
                      required
                      value={name}
                      error={showInputError && name === ""}
                      className={classes.textField}
                      onChange={(e) => setName(e.target.value)}
                    />
                    {showInputError && name === "" && (
                      <FormHelperText className={classes.error}>Name Required</FormHelperText>
                    )}
                  </Grid>
                  <Grid xs={12} sm={6} item>
                    <StyledTextField
                      InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                      placeholder="End Point"
                      label="End Point"
                      variant="standard"
                      fullWidth
                      required
                      value={endpoint}
                      error={showInputError && endpoint === ""}
                      className={classes.textField}
                      onChange={(e) => setEndpoint(e.target.value)}
                    />
                    {showInputError && endpoint === "" && (
                      <FormHelperText className={classes.error}>End Point Required</FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <StyledTextField
                      InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                      placeholder="Output Filename"
                      label="Output Filename"
                      variant="standard"
                      fullWidth
                      required
                      value={outputFileName}
                      error={showInputError && outputFileName === ""}
                      className={classes.textField}
                      onChange={(e) => setOutputFileName(e.target.value)}
                    />
                    {showInputError && outputFileName === "" && (
                      <FormHelperText className={classes.error}>Output Filename Required</FormHelperText>
                    )}
                  </Grid>
                  {renderExtraFields()}
                  <Grid item xs={12} sm={12} container justifyContent="flex-end">
                    <Button
                      style={{ marginTop: "20px", marginRight: "8px" }}
                      className={classes.sensitiveButton}
                      type="submit"
                      variant="contained"
                      color="primary"
                      onClick={() =>
                        checkAllEntered() ? callAPI(editApi(data), "API Saved") : setShowInputError(true)
                      }
                    >
                      Save Information
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <div className={classes.sensitiveSection}>
              <Grid item xs={12} sm={12} container justifyContent="space-between">
                <Button
                  className={classes.sensitiveButton}
                  type="submit"
                  variant="contained"
                  color="secondary"
                  onClick={() => setOpenModal(true)}
                >
                  Delete API
                </Button>
              </Grid>
            </div>
          </Grid>
        </div>
      </div>
      <Dialog open={openModal} onClose={() => setOpenModal(false)}>
        <ConfirmationModal
          question="Delete this API permanently?"
          func={() => callAPI(callDelete(location.state.id), "API Deleted")}
          closeModal={() => setOpenModal(false)}
          processing={processing}
        />
      </Dialog>
    </>
  );
}

export default AtsApiDetailed;
